import { createContext, useContext, useState, useEffect } from "react";

const PaymentContext = createContext(null);

export const PaymentProvider = ({ children }) => {
    const [step, setStep] = useState(() => {
        return parseInt(localStorage.getItem("paymentStep")) || 0;
    });

    useEffect(() => {
        localStorage.setItem("paymentStep", step);
    }, [step]);

    return (
        <PaymentContext.Provider value={{ step, setStep }}>
            {children}
        </PaymentContext.Provider>
    );
};

export const usePayment = () => {
    const context = useContext(PaymentContext);
    if (!context) {
        throw new Error("usePayment 必須在 <PaymentProvider> 內使用");
    }
    return context;
};
